module.exports = function (data) {
    return {
        cart: {
            packagingPreference: data,
        },
    };
};



// WEBPACK FOOTER //
// ./src/order/packaging/analytics/packaging-preference-analytics-mapper.js